import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import Contest from '../components/Contest';
import Flavors from '../components/Flavors';
import ComingSoon from '../components/ComingSoon';
import Ingredients from '../components/Ingredients';
import BuildBowl from '../components/BuildBowl';
import WhatYouWont from '../components/WhatYouWont';
import CrunchLevel from '../components/CrunchLevel';
import Reviews from '../components/Reviews';
import FAQ from '../components/FAQ';
import Partner from '../components/Partner';
import Contact from '../components/Contact';
import FinalCTA from '../components/FinalCTA';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="bg-[#FFF4E6] min-h-screen">
      <Navbar />
      <Hero />
      <Marquee />
      <Contest />
      <Ingredients />
      <Flavors />
      <ComingSoon />
      <BuildBowl />
      <WhatYouWont />
      <CrunchLevel />
      <Reviews />
      <FAQ />
      <Partner />
      <Contact />
      <FinalCTA />
      <Footer />
    </div>
  );
};

export default Home;
